import { getRoute } from '@/constants';
import type { SavedJobListItemDto } from '@/modules/job/contracts';

import type { SavedJobListItemVM } from '../models/saved-job.view-model';

export const savedJobListItemDtoToVM = (dto: SavedJobListItemDto): SavedJobListItemVM => {
	return {
		id: dto.id,

		companyName: '',
		coverImage:  dto.coverImage!,
		detailUrl:   getRoute.jobs.detail(dto.id),
		entryUrl:    getRoute.jobs.apply(dto.id),
		expiredAt:   dto.expiredAt,
		location:    dto.locationDetail ?? '',
		postedAt:    dto.postedAt,
		status:      dto.status,
		title:       dto.title,

		salary: {
			max: dto.estimatedSalaryMax ?? null,
			min: dto.estimatedSalaryMin ?? null,
		},
	};
};
